import React from "react";
import Loading from "../components/Loading/Loading";
import { AppContextType } from "../libs/Interfaces";

const AppContext = React.createContext<AppContextType>({
    loadingComponent: (<Loading />),
    installable: false,
    install: () => console.log("INSTALL"),
    position: null
});

export function useApp() {
    return React.useContext(AppContext);
}

let deferredPrompt: any;
let watchid: number;

export function AppProvider({ children }: { children: any }) {

    const [installable, setInstallable] = React.useState(false);
    const [position, setPosition] = React.useState<GeolocationCoordinates | null>(null);

    async function getLocation() {
        if (!window.navigator) return;
        window.navigator.geolocation.getCurrentPosition(pos => {
            console.log(pos);
            let watch = window.navigator.geolocation.watchPosition((pos) => {
                setPosition(pos.coords);
            }, console.error, { enableHighAccuracy: true, maximumAge: 10, timeout: Infinity });
            watchid = watch;
        },console.error);
    }

    function closeLocationWatch() {
        if (watchid && window.navigator) window.navigator.geolocation.clearWatch(watchid);
    }

    function install() {
        setInstallable(false);
        // Show the install prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult: any) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
            } else {
                console.log('User dismissed the install prompt');
            }
        });
    };

    React.useEffect(() => {
        getLocation();
        window.addEventListener("beforeinstallprompt", (e: any) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;
            // Update UI notify the user they can install the PWA
            setInstallable(true);
        });
        window.addEventListener('appinstalled', () => {
            // Log install to analytics
            console.log('INSTALL: Success');
        });
        let removeEventListenersAndUnsubscribe = () => {
            window.removeEventListener("beforeinstallprompt", console.log);
            window.removeEventListener("appinstalled", console.log);
            closeLocationWatch();
        };
        //return removeEventListeners;
        return removeEventListenersAndUnsubscribe;
    }, []);

    const value: AppContextType = {
        loadingComponent: (<Loading />),
        installable,
        install,
        position
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
}